import {Component,Inject, Input} from 'ng-metadata/core';
import {VirtualBrowseItem} from '../virtualBrowse.service';


@Component({
selector: 'prm-virtual-browse-item',
templateUrl: 'components/search/virtualBrowse/virtualBrowseItem/virtual-browse-item.html',
})



export class PrmVirtualBrowseItem{
    @Input() private virtualBrowseItem: VirtualBrowseItem;
    private renderFlag: boolean= true;
    private tooltipDelay;
    constructor(@Inject('$scope') private $scope: ng.IScope,
                @Inject('$timeout') private $timeout: ng.ITimeoutService) {
    }
    
    ngOnInit(){
        this.$scope.$watch(()=>this.virtualBrowseItem, ()=> { //this is done in order to re render the thumbnail directive when the virtual browse item changes
            this.renderFlag= false;
            this.$timeout(()=>{this.renderFlag= true}, 0);
            this.tooltipDelay = '500';
        });
    }
    

}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/virtualBrowse/virtualBrowseItem/virtualBrowseItem.directive.ts